<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  /*Import Main styles for this application*/
  @import './scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue